import { brandConfig } from '@brand-current';
import type { ScreenId } from '@/app/navigation/types';

// Единственная точка доступа к варианту инстанса. Импортировать НУЖНО отсюда
// (`import { brand } from '@/brand'`), а не из конкретного src/brand/<name> —
// иначе в бандл уедет конфиг чужого бренда.
//
// Какой модуль подставится, решает vite по --mode (alias '@brand-current' в
// vite.config.ts). Для tsc алиас разрешён в tsconfig.json paths на serious —
// типы у всех брендов одни и те же (BrandConfig).
export const brand = brandConfig;

// Для кросс-ссылок из одного экрана на другой: у бренда экран может быть
// выключен, и тогда ссылка ведёт в 404 (роут просто не собирается —
// см. buildRoutes). Это не ветвление по бренду, а проверка доступности
// адресата: «есть ли куда вести».
export const hasScreen = (id: ScreenId) => brand.screens.includes(id);

export * from './types';
export { validateBrandConfig } from './validate';
